import { useSyncExternalStore } from "react";

/** Why a favourite could not be saved: the list was full (409) or the write failed. */
export type FavouriteNotice = "full" | "failed";

let current: FavouriteNotice | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;
const listeners = new Set<() => void>();

function set(next: FavouriteNotice | null) {
  current = next;
  for (const l of listeners) l();
}

/** Shows the notice for a few seconds (the hook that rolled the star back calls this). */
export function notifyFavouriteError(kind: FavouriteNotice): void {
  clearTimeout(timer);
  set(kind);
  timer = setTimeout(() => set(null), 6000);
}

export function dismissFavouriteNotice(): void {
  clearTimeout(timer);
  set(null);
}

export function useFavouriteNotice(): FavouriteNotice | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => void listeners.delete(cb);
    },
    () => current,
    () => null,
  );
}
